import { appInsights } from "us.helper";
import { CaseType } from "us.helper/types/enums";
import { ICase } from "us.collection.transactions/interfaces";

/**
 * @function
 * @description - Check for the validitity for the Case creation
 * @param {ICase[]} selectedSubCases - selected sub cases
 * @param {boolean} isValidSubCasesSelect -isValidSubCasesSelect
 * @return {*}  {boolean} - boolean decision for ability to case creation
 */
export const isSelectedCasesInValidForCaseCreation = (
  selectedSubCases: ICase[],
  isValidSubCasesSelect: boolean,
): boolean => {
  try {
    if (isValidSubCasesSelect || selectedSubCases.length === 1) {
      return (
        selectedSubCases.filter(
          (subCase) =>
            subCase.parentId === 0 &&
            subCase.caseType == CaseType.S &&
            subCase.isCreateEnabled,
        ).length == 0 ||
        selectedSubCases?.filter((x) => x.parentId > 0).length > 0
      );
    } else {
      return true;
    }
  } catch (error) {
    appInsights.trackException(
      `Cases and Subcases Home isCreateCaseButtonDisabled error - ${error}`,
    );
    return true;
  }
};
